import { useQueryClient } from '@tanstack/react-query';
const RECORD_LIST_QUERY_KEY = ['research', 'record', 'find'];
const RECORD_LOOKUP_QUERY_KEY = ['research', 'record', 'lookup'];
export function getRecordListQueryKey(props) {
    return [...RECORD_LIST_QUERY_KEY, props];
}
export function getRecordLookupKey(contentId) {
    return [...RECORD_LOOKUP_QUERY_KEY, { contentId }];
}
export function createRecordRepository(config) {
    const { repository, client } = config;
    const DEFAULT_LIMIT = 50;
    return {
        usePrefetchFind(context) {
            const queryClient = useQueryClient();
            return {
                trigger(props) {
                    return queryClient.prefetchQuery({
                        queryKey: getRecordListQueryKey(props),
                        async queryFn() {
                            const { ids, ...rest } = props;
                            if (ids) {
                                // TODO move to backend
                                const response = await Promise.all(ids.map(async (id) => {
                                    return await client.user.content.retrieve(id);
                                }));
                                return response;
                            }
                            const response = await client.user.content.list({
                                ...rest,
                                limit: props.limit ?? DEFAULT_LIMIT,
                            });
                            return response.data;
                        },
                    });
                },
            };
        },
        useFind(context, props, options) {
            const queryClient = useQueryClient();
            const query = repository.useQuery({
                ...options,
                queryKey: getRecordListQueryKey(props),
                async queryFn() {
                    const { ids, ...rest } = props;
                    if (ids) {
                        // TODO move to backend
                        const response = await Promise.all(ids.map(async (id) => {
                            return await client.user.content.retrieve(id);
                        }));
                        return response;
                    }
                    const { data: records } = await client.user.content.list({
                        ...rest,
                        limit: props.limit ?? DEFAULT_LIMIT,
                    });
                    return records;
                },
                onSuccess(data) {
                    for (const record of data) {
                        const queryKey = getRecordLookupKey(record.id);
                        queryClient.setQueryData(queryKey, record);
                    }
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getRecordLookupKey(props.contentId),
                async queryFn() {
                    const record = await client.user.content.retrieve(props.contentId);
                    return record;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=recordRepository.js.map